import React from "react";
import { Tabs } from "antd";
import { useHistory, useParams } from "react-router-dom";

const { TabPane } = Tabs;

// Second-level tabs inside a module page, each with its own address
// (/app/<module>/<tab>/<sub>), so they can be linked and the browser's Back
// button steps through them. The route must declare :tab? and :sub?.
// items: [{ key, label, render: () => node }]
const ModuleSubTabs = ({ basePath, items }) => {
  const history = useHistory();
  const { sub } = useParams();
  const active = items.some((item) => item.key === sub) ? sub : items[0].key;

  return (
    <Tabs activeKey={active} onChange={(key) => history.push(`${basePath}/${key}`)}>
      {items.map((item) => (
        <TabPane tab={item.label} key={item.key}>
          {item.key === active ? item.render() : null}
        </TabPane>
      ))}
    </Tabs>
  );
};

export default ModuleSubTabs;
